import { render, staticRenderFns } from "./ToolbarTextareaFontFamily.vue?vue&type=template&id=47f3b863"
import script from "./ToolbarTextareaFontFamily.vue?vue&type=script&lang=js"
export * from "./ToolbarTextareaFontFamily.vue?vue&type=script&lang=js"
import style0 from "./ToolbarTextareaFontFamily.vue?vue&type=style&index=0&id=47f3b863&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports